var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackrestLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12701 3.77905V11.7791H13.127L3.12701 3.77905Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.807 5.09405H11.797V4.47205C11.797 4.08905 11.487 3.77905 11.104 3.77905C10.721 3.77905 10.411 4.08905 10.411 4.47205V5.09405H10.4H10.13C9.95699 5.75205 9.95699 6.24405 10.13 6.57105C10.389 7.06205 10.801 6.98005 11.127 6.98005C11.453 6.98005 11.85 7.02205 12.077 6.57205C12.228 6.27205 12.228 5.77905 12.077 5.09505H11.807V5.09405ZM11.275 5.89105V6.26905H10.932V5.89105C10.865 5.83905 10.826 5.75905 10.826 5.67305C10.826 5.52005 10.95 5.39605 11.103 5.39605C11.256 5.39605 11.381 5.52005 11.381 5.67305C11.381 5.75905 11.342 5.83905 11.275 5.89105ZM11.536 5.09405H10.671V4.47205C10.671 4.23405 10.865 4.04005 11.103 4.04005C11.341 4.04005 11.535 4.23405 11.535 4.47205V5.09405H11.536Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackrestLock);
export default __webpack_public_path__ + "static/media/backrest_lock.29eea3cc.svg";
export { ForwardRef as ReactComponent };